import React, { useEffect, useState } from 'react';
import { trackEvent } from 'utils';

import { StorageKey } from '../../constants';

type NewsSummaryToggleProps = {
  newsId: string | string[];
  isCheckedToggle: boolean;
  toggleSummary: () => void;
};

export const NewsSummaryToggle = ({ isCheckedToggle, toggleSummary, newsId }: NewsSummaryToggleProps) => {
  const handleToggleChange = () => {
    toggleSummary();
    trackEvent('설정_클릭', {
      page: '뉴스상세_계약',
      eventLabel_1: `${!isCheckedToggle ? 'ON' : 'OFF'}`,
      eventDetail_1: `${newsId}`,
    });
  };

  return (
    <div className="summaryToggle">
      <input
        type="checkbox"
        id="summaryCheck"
        name="summaryCheck"
        checked={isCheckedToggle}
        onChange={handleToggleChange}
      />
      <label htmlFor="summaryCheck"></label>
      <NewsSummaryToggleToolTip isCheckedToggle={isCheckedToggle} />
    </div>
  );
};

type NewsSummaryToggleToolTipProps = {
  isCheckedToggle: boolean;
};
const NewsSummaryToggleToolTip = ({ isCheckedToggle }: NewsSummaryToggleToolTipProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const showTooltip = localStorage.getItem(StorageKey.ShowSummaryTooltip) !== 'false';
    setShowTooltip(showTooltip);
  }, []);

  useEffect(() => {
    hideTooltip();
  }, [isCheckedToggle]);
  const hideTooltip = () => {
    if (showTooltip) {
      setShowTooltip(false);
      localStorage.setItem(StorageKey.ShowSummaryTooltip, 'false');
    }
  };

  if (!showTooltip) {
    return null;
  }

  return (
    <div className={`tooltipWrap ${showTooltip ? ' block' : 'hide'}`}>
      <div className="tooltip" onClick={hideTooltip}>
        <button className="btnClose" type="button">
          <span className="a11y">요약 버튼 안내 닫기</span>
        </button>
        <p className="tooltipTxt">
          뉴스 모드를 <br />
          변경할 수 있어요.
        </p>
      </div>
    </div>
  );
};
